// extracted by mini-css-extract-plugin
export default {"title":"EmployeeManagement_title__GNMlH"};